import { Reveal, ChapterHead } from "./shared";

const SPECS = [
  { label: "Height", value: "Approx. 30 cm / 12 inches" },
  { label: "Gemstone Chips", value: "Approximately 300" },
  { label: "Weight", value: "Approximately 200–300 g" },
  { label: "Construction", value: "Handcrafted wire branches" },
  { label: "Base", value: "Decorative wooden-style base" },
  { label: "Category", value: "Handcrafted Home Décor" },
  { label: "Product Type", value: "7 Chakra Gemstone Decorative Tree" },
];

export default function Details() {
  return (
    <section id="details" className="py-20 lg:py-32 bg-[#F4F0E6]/50" data-testid="details-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-12 gap-14 lg:gap-20 items-start">
        <div className="lg:col-span-4 lg:sticky lg:top-28">
          <ChapterHead number="06" label="Product Details" title="The Details" testid="details" />
          <Reveal delay={0.15}>
            <p className="mt-8 text-base text-[#1A201C]/65 leading-relaxed" data-testid="details-intro">
              Every specification, clearly stated — so you know exactly what arrives
              in your hands.
            </p>
            <img
              src="/assets/tree.webp"
              alt="7 Chakra Gemstone Tree detail"
              className="mt-10 w-40 object-contain drop-shadow-[0_24px_24px_rgba(13,40,24,0.18)]"
              data-testid="details-tree-image"
            />
          </Reveal>
        </div>

        <Reveal delay={0.2} className="lg:col-span-8">
          <div
            className="border border-[#1B1915]/12 bg-[#FDFBF7] rounded-sm divide-y divide-[#1B1915]/10"
            data-testid="details-spec-panel"
          >
            {SPECS.map((s) => (
              <div
                key={s.label}
                className="grid sm:grid-cols-[220px_1fr] gap-1 sm:gap-6 px-7 sm:px-10 py-6 hover:bg-[#F4F0E6]/60 transition-colors duration-300"
                data-testid={`spec-row-${s.label.toLowerCase().replace(/\s+/g, "-")}`}
              >
                <span className="text-[11px] tracking-[0.22em] uppercase text-[#8C7A56]/75 pt-1">
                  {s.label}
                </span>
                <span className="font-serif-display text-xl sm:text-2xl text-[#1B1915] tracking-tight">
                  {s.value}
                </span>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
